module.exports = __webpack_public_path__ + "img/eleftherios_gryparis.048bd1d6.jpeg";